import { useState, useCallback, useEffect } from 'react';

export type SliderTab = 'match' | 'matches';

export function useSliderRouting() {
  const [activeTab, setActiveTab] = useState<SliderTab>('match');

  // Parse hash and update tab state
  const parseHashAndUpdateTab = useCallback(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'match' || hash === 'matches') {
      setActiveTab(hash);
    }
  }, []);

  // Initialize tab from hash on mount
  useEffect(() => {
    parseHashAndUpdateTab();
  }, [parseHashAndUpdateTab]);

  // Listen for hash changes
  useEffect(() => {
    const onHashChange = () => {
      parseHashAndUpdateTab();
    };
    
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [parseHashAndUpdateTab]);

  // Navigate to tab and update hash
  const navigateToTab = useCallback((tab: SliderTab) => {
    setActiveTab(tab);
    window.location.hash = tab;
  }, []);

  return {
    activeTab,
    navigateToTab,
  };
}